// Step-up re-auth field (design-notes-stepup-reauth-sensitive-actions, Phase 4). Embedded in
// the destructive-action dialogs (base closure, aircraft deactivate/relocate, staff deactivate).
// Password now; the TOTP field is wired but hidden until 2FA ships (additive — no contract
// change). The SERVER is the gate; this is the prompt. Reuses the app theme (C.*).

import type { CSSProperties } from 'react';
import { C, F } from '../ops-board/theme';

const inp: CSSProperties = { fontFamily: F, fontSize: 13, padding: '6px 8px', border: `1px solid ${C.borderMed}`, borderRadius: 6, width: '100%' };
const lbl: CSSProperties = { fontWeight: 600, fontSize: 12, color: C.textDim, display: 'block', marginBottom: 3 };

// 2FA-ready: the host dialog may also hold totp state and pass it through later; today only
// the password is collected, so totp/setTotp are accepted but unused until 2FA ships.
// `notice` overrides the default destructive-action line for non-destructive step-up hosts
// (e.g. the Profile device-PIN reset, PR-000042); existing callers are unchanged.
export function StepUpFields({ password, setPassword, notice }: {
  password: string;
  setPassword: (v: string) => void;
  totp?: string;
  setTotp?: (v: string) => void;
  notice?: string;
}) {
  return (
    <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px dashed ${C.borderMed}` }}>
      <div style={{ fontSize: 12, color: C.amber, marginBottom: 6 }}>{notice ?? '🔒 This is a destructive action — confirm with your password.'}</div>
      <label style={lbl}>Your password <span style={{ color: C.red }}>*</span></label>
      <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} style={inp} />
      {/* 2FA-ready: unhide when TOTP ships (verifyStepUp already accepts creds.totp).
      <label style={{ ...lbl, marginTop: 8 }}>Authenticator code</label>
      <input type="text" inputMode="numeric" value={totp ?? ''} onChange={(e) => setTotp?.(e.target.value)} style={inp} /> */}
    </div>
  );
}
